import $ from 'jquery';
import Mustache from 'mustache';

export class SiteSearch {

    element;
    overallResultsElement;
    activityResultsElement;
    peopleResultsElement;
    activityUrl;
    userUrl;
    scheduledSearch;

    constructor(element, resultsElement) {
        this.element = $(element);
        this.overallResultsElement = resultsElement;
        this.activityResultsElement = $(resultsElement).find('.activities');
        this.peopleResultsElement = $(resultsElement).find('.users');
        this.activityUrl = this.element.data('activityUrl');
        this.userUrl = this.element.data('userUrl');
        this.bindEvents();
    }

    bindEvents() {
        this.element.keyup(_ => {
            this.setTimeout();
        });

        //$('.navbar').mouseleave(_ => {
        //    this.overallResultsElement.addClass('d-none');
        //});
    }

    find() {
        this.clearTimeout();

        $.ajax({
            url: this.activityUrl,
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(this.getActivityInputs()),
            success: (response) => {
                this.overallResultsElement.removeClass('d-none');
                response.keyword = this.element.val();
                const html = Mustache.render($('#topbar-search-activity').html(), response);
                this.activityResultsElement.html(html);
            }
        });

        $.ajax({
            url: this.userUrl,
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(this.getUserInputs()),
            success: (response) => {
                this.overallResultsElement.removeClass('d-none');
                response.keyword = this.element.val();
                const html = Mustache.render($('#topbar-search-user').html(), response);
                this.peopleResultsElement.html(html);
            }
        });
    }

    setTimeout(timeout = 300) {
        this.clearTimeout();
        this.scheduledSearch = setTimeout(_ => {
            this.find();
        }, timeout);
    }

    clearTimeout() {
        if (this.scheduledSearch !== null) {
            clearTimeout(this.scheduledSearch);
        }
    }

    getActivityInputs() {
        return {
            title: this.element.val(),
            distance: 50000,
            perPage: 5,
            mosOnly: 0,
            seatsAvailable: 0,
            new: 0,
            page: 1,
            context: 'site-search',
            _token: $('meta[name="csrf-token"]').attr('content')
        };
    }

    getUserInputs() {
        return {
            name: this.element.val(),
            perPage: 5,
            page: 1,
            context: 'site-search',
            _token: $('meta[name="csrf-token"]').attr('content')
        };
    }

}
